import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  id: number,
 *  name: number }} FileResponse
 */

const api = new Api("api/files");

/**
 * @param {number} id
 * @returns {Promise<AxiosResponse<File>>}
 */
export const getById = (id) => api.getFile(id);

/**
 * @param {number} projectId
 * @returns {Promise<AxiosResponse<File>>}
 */
export const getByProjectId = (projectId) =>
  api.getFile(`project/${projectId}`);

/**
 * @param {number[]} filesIds
 * @param {string} fileName
 * @returns {Promise<AxiosResponse<File>>}
 */
export const getZipFileByIdsAsync = (filesIds, fileName) =>
  api.postWithBlobResponse(`zipfile`, { filesIds, fileName });

/**
 * @param {File} file
 * @param {number} fileAssociationId
 * @param {number} fileAssociationObjectId
 * @param {number} municipalityId
 * @param {number} year
 * @param {Function} onUploadProgress
 * @returns {Promise<AxiosResponse<FileResponse>>}
 */
export const uploadFile = (
  file,
  fileAssociationId,
  fileAssociationObjectId,
  municipalityId,
  year,
  onUploadProgress = null
) => {
  const formData = new FormData();
  formData.append("year", year);
  formData.append("fileAssociationId", fileAssociationId);
  formData.append("fileAssociationObjectId", fileAssociationObjectId);
  formData.append("municipalityId", municipalityId);
  formData.append("file", file);
  return api.post("", formData, { onUploadProgress });
};

export const uploadMultipleFiles = (
  files,
  fileAssociationId,
  fileAssociationObjectId,
  municipalityId,
  year,
  onUploadProgress = null
) => {
  const formData = new FormData();
  formData.append("year", year);
  formData.append("fileAssociationId", fileAssociationId);
  formData.append("fileAssociationObjectId", fileAssociationObjectId);
  formData.append("municipalityId", municipalityId);
  files?.map((file) => formData.append("files", file));
  return api.post("multiple", formData, { onUploadProgress });
};

export const remove = (id, fileAssociationObjectId = 0) =>
  api.del(`${id}/${fileAssociationObjectId}`);

export const removeAllBankingInformationFiles = () =>
  api.post(`banking-information-files`);

/**
 * @param {number} year
 * @returns {string}
 */
export const getQuestionnairesAssetManagementPlansURL = (year) =>
  api.getFile(`questionnaires/year/${year}`);

/**
 * @param {number} year
 * @returns {string}
 */
export const getReconciliationsURL = (year) =>
  api.getFile(`reconciliationChange/year/${year}`);
